import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { PracticeService } from "../../../core/services/v2/practice.service";
import { WindowLoaderService } from "../../../shared/components/window-loader/window-loader.service";
import { FormFolder } from "../../../core/models/physician/form-folder";
import { FormService } from "../../../core/services/v2/form.service";
import * as _ from "lodash";
import { MatDialog, MatSnackBar } from "@angular/material";
import { FolderEditdialogComponent } from "./folder-editdialog/folder-editdialog.component";

@Component({
  selector: "app-form-folder-management",
  templateUrl: "./form-folder-management.component.html",
  styleUrls: ["./form-folder-management.component.scss"],
})
export class FormFolderManagementComponent implements OnChanges {
  @Input() formFolders: FormFolder[];
  @Output() toggleEvent = new EventEmitter();
  formGroupList: FormFolder[];
  errorMessage: string;

  constructor(
    public dialog: MatDialog,
    private practiceService: PracticeService,
    private formService: FormService,
    private loaderService: WindowLoaderService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnChanges() {
    this.listFolders();
  }

  listFolders() {
    this.loaderService
      .blockWithLoader(this.formService.getFormsGroups())
      .subscribe(
        (templ) => {
          console.log(templ.result);
          console.log(this.formService.activeFormFolders);
          this.formGroupList = templ.result;
        },
        (error) => {
          console.error(error);
        }
      );
  }
  saveFolder(formFolder: FormFolder) {
    this.errorMessage = "";
    if (formFolder.name) {
      if (formFolder.id && formFolder.id > 0) {
        this.loaderService
          .blockWithLoader(this.formService.updateFormFolder(formFolder))
          .subscribe(
            (templ) => {
              if (templ.resultStatus.isSuccess) {
                //console.log(templ);
                formFolder = templ.result;

                this.listFolders();
                // this.toggleEvent.emit(this.formFolders);
              } else {
                console.error(templ.resultStatus);
                this.errorMessage = "Folder could not be saved";
              }
            },
            (error) => {
              console.error(error);
              this.errorMessage = "Folder could not be saved";
            }
          );
      } else {
        this.loaderService
          .blockWithLoader(this.formService.addFormFolder(formFolder))
          .subscribe(
            (templ) => {
              if (templ.resultStatus.isSuccess) {
                formFolder = templ.result;

                this.listFolders();
                // this.toggleEvent.emit(this.formFolders);
              } else {
                console.error(templ);
                this.errorMessage = "Folder could not be saved";
              }
            },
            (error) => {
              console.error(error);
              this.errorMessage = "Folder could not be saved";
            }
          );
      }
    }
  }

  addFolder() {
    this.formGroupList.push(new FormFolder());
  }

  deleteFolder(ind: number, formFolder: FormFolder) {
    let f = _.filter(this.formService.activeFormFolders, { id: formFolder.id });
    if (!f[0].forms) {
      this.errorMessage = "";
      if (formFolder.id && formFolder.id > 0) {
        this.loaderService
          .blockWithLoader(this.formService.deleteFormFolder(formFolder))
          .subscribe(
            (templ) => {
              if (templ.resultStatus.isSuccess) {
                this.formGroupList.splice(ind, 1);
              } else {
                console.error(templ.resultStatus);
              }
            },
            (error) => {
              console.error(error);
              this.errorMessage = "Folder could not be deleted";
            }
          );
      }
    } else {
      this._snackBar.open("Folder contain forms", "Ok", {
        duration: 5000,
      });
    }
  }

  save() {
    this.listFolders();
    this.loaderService
      .blockWithLoader(this.formService.getFormsDocs(""))
      .subscribe(
        (templ) => {
          this.formFolders = templ.result;
          // this.formService.activeFormFolders = templ.result;
          let templist = _.filter(templ.result, (f) => f.id != -1);
          this.formService.activeFormFolders = _.orderBy(
            templist,
            [(folder) => folder.name.toLowerCase()],
            ["asc"]
          );

          this.toggleEvent.emit(this.formFolders);
        },
        (error) => {
          console.error(error);
          this.toggleEvent.emit(this.formFolders);
        }
      );
    // this.toggleEvent.emit(this.formFolders);
  }

  openDialog(obj) {
    const dialogRef = this.dialog.open(FolderEditdialogComponent, {
      width: "300px",
      data: obj,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) this.saveFolder(result.data);
    });
  }
}
